module.exports = __webpack_public_path__ + "omniv2/img/Personalised-Rate.0b08180a.svg";